import { useConflictCard } from "../gantt-carga/hooks/use-conflict-card";
import type { ConflictBandProps, ConflictBandViewModel } from "./types-conflict-band";

export function useConflictBand({
  groups,
  left,
  width,
  className,
  tratado = false,
}: ConflictBandProps): ConflictBandViewModel {
  const { anchorProps, card } = useConflictCard();

  return {
    groups,
    className,
    style: { left: `${left}%`, width: `${width}%` },
    tratado,
    rotulo: tratado ? "Conflito ignorado" : "Conflito detectado",
    testId: tratado ? "gantt-conflict-band-ignored" : "gantt-conflict-band",
    anchorProps,
    card,
  };
}
